window.Cropper = require('cropperjs');
